import { constantsData, formFieldNamesData } from "@/data";
import { AsyncDataKeyEnum, FieldTypeEnum } from "@/enums";

const { category } = constantsData.forms.dataSources.moveToCategory;

const { category: categoryFieldName } = formFieldNamesData;

export const moveDataSourceToCategoryFormData = [
    {
        dataKey: AsyncDataKeyEnum.CATEGORIES,
        isAsync: true,
        label: category.label,
        name: categoryFieldName,
        type: FieldTypeEnum.SELECT,
    },
];
